import React from 'react';
import { RadioButton } from "./RadioButton";
import { StepDescription } from './StepDescription';
import { CustomizerLabelData } from "../types/ProductCustomizer";
import * as currency from "@shopify/theme-currency";
import { Transition } from 'react-transition-group';
import { useEffect } from "react";
import { shippingEstimate } from '../utils/shippingEstimate';

export const ProductCustomizerStep = ({ state, stateCameraWizard, product, step, index, getVariantPriceDifference, getProductPriceDifference, handleProductChange, handleOptionChange, handleUpdatedOption, handleFieldChange, dispatch }) => {
  const displayMeasurements = false;

  /*
    Fade animation between steps
  */
 
  // Animation adjustment: Check if flow contains step, apply different transition to step index 1

  const intro = state.steps.findIndex((step) => step.id === "intro");
  let flowContainsIntro = false;
  if (intro !== -1) flowContainsIntro = true;

  let defaultStyle = {
    transition: `opacity 300ms ease`,
    opacity: 1
  };
  
  let transitionStyles = {
    entering: { opacity: 0, display: "block" },
    entered: { opacity: 1, display: "block" },
    exiting: { opacity: 1, display: "none" },
    exited: { opacity: 0, display: "none" },
  };

  if (step.id === "intro" || flowContainsIntro && index === 1) {
    transitionStyles.exiting.opacity = 0;
  } else {
    defaultStyle.opacity = 0;
  }

  

  return (
    <Transition in={state.activeStep === index} timeout={100}>
      {(transitionState) => (
        <div
            style={{...defaultStyle, ...transitionStyles[transitionState]}}
          >
            <div className="pt-[2rem] md:pt-[max(10vh_,_2rem)]">
              <h2 className={`normal-case text-center flex justify-center items-center ${step.id === "intro" ? 'text-4xl md:text-6xl new-h3' : 'new-h6'}`} dangerouslySetInnerHTML={{ __html: step.title }}></h2>
              {step.subtitle && <h3 className={`mt-[1rem] ${step.id === "intro" ? 'text-center new-h6' : ''}`}>{step.subtitle}</h3>}
              {step.description && <StepDescription description={step.description} stepId={step.id} />}
              {step.id==="circumference" ?<div className={"text-[1rem] mt-[1.75rem] leading-7 text-center "}>AI Measurement: {stateCameraWizard.capSize===undefined?<span className={'text-green-600'}>Skipped</span>:<span className={'text-green-600'}>{stateCameraWizard.capSize}</span>} </div>:<div></div>}
              {step.id==="Lace_Tint" ?<div className={"text-[1rem] mt-[1.75rem] leading-7 text-center  "}>AI Recommendation: {stateCameraWizard.laceTintDescription==undefined?<span  className={'text-green-600'} >Skipped</span>:( <div><br></br><span className={"leading-4 text-green-600"}>{stateCameraWizard.laceTintDescription}</span></div>)} </div>:<div></div>}
              <div className="mt-[1rem] md:mt-[2rem]">
                {step.options && step.options.map((opt, i) => {

                  let labelData: CustomizerLabelData = {
                    title: opt.label,
                    description: opt.description,
                    image: opt.image
                  }

                  if (step.type === "variant") {
                   
                    const difference = getVariantPriceDifference(step.id, opt.id);
                    if (difference !== null) labelData.price_diff = currency.formatMoney(difference, "${{amount_no_decimals}}");
                  }

                  if (step.type === "product") {
                    const difference = getProductPriceDifference(opt.id);
                    if (difference !== null) labelData.price_diff = currency.formatMoney(difference, "${{amount_no_decimals}}");
                  
                    return <RadioButton
                      id={`${step.id}-${i}`}
                      name={step.id}
                      labelData={labelData}
                      value={opt.label}
                      onChange={() => handleProductChange( opt.id )}
                      checked={i === state.selectedOptions[index]}
                      className=""
                    />
                  }
                 
                  return <RadioButton
                    id={`${step.id}-${i}`}
                    name={step.id}
                    labelData={labelData}
                    value={opt.label}
                    onChange={() => {
                      handleOptionChange("selectedOptions", index, i);
                      handleUpdatedOption(index, i);
                    }}
                    checked={i === state.selectedOptions[index]}
                    className=""
                  />
                })
                }
              </div>

              {step.id === "summary" &&
                <div>
                  {state.selectedOptions.map((opt, i) => {
                    const step = state.steps[i];
                    if (step.type === "content") return;

                    // Fix for when step has removed unavailable option (e.g. Bangs = Yes) and selectedOptions hasn't been updated to reflect that change yet - To be improved
                    const optionMatch = step.options[opt];
                    if (!optionMatch) return null;

                    return (
                      <div>
                        <dl className="text-sm">

                          <dt className="font-medium mt-[1.5rem] mb-[0.25rem]">{step.title}</dt>
                          <dd>{(step.title==="what is your head circumference (inches)?" && step.options[opt].label==="Use AI Measurement"&&stateCameraWizard.capSize!=undefined)?
                          stateCameraWizard.capSize:(step.title==="what is your head circumference (inches)?" && step.options[opt].label==="Use AI Measurement"&&stateCameraWizard.capSiz==undefined)?
                          "None":(step.title==="What color lace tint do you want?" && (step.options[opt].label==="Use AI Recommendation"&&stateCameraWizard.laceTintDescription!=undefined))?
                          stateCameraWizard.laceTintDescription:(step.title==="What color lace tint do you want?" && (step.options[opt].label==="Use AI Recommendation"&&stateCameraWizard.laceTintDescription==undefined))?
                          "None":step.options[opt].label}</dd>
                        </dl> 
                      </div>
                    )
                  })}
                  {displayMeasurements ?
                    <>
                      <dl className="text-sm">
                        <dt className="font-medium mt-[1.5rem] mb-[0.25rem]">Cap size</dt>
                        <dd>{stateCameraWizard.capSize}</dd>
                      </dl>
                      <dl className="text-sm">
                        <dt className="font-medium mt-[1.5rem] mb-[0.25rem]">Lace tint</dt>
                        <dd className="flex items-center">
                          <span className={`w-[1rem] h-[1rem] rounded-[50%]`} style={{ background: stateCameraWizard.laceTint }}></span>
                          <span className="ml-[0.25rem]">{stateCameraWizard.laceTint}</span>
                        </dd>
                      </dl>
                    </>
                    :<></>

                  }
                </div>

              }

              {step.id === "summary" &&
                <>
                  <div className="mt-[1.5rem] pt-[1.5rem] flex justify-between items-center border-t border-taupe-600 text-xs font-bold">
                    {/* {(state.variant.compare_at_price&&state.variant.price!==state.variant.compare_at_price)?<><p className="text-xs font-bold">Subtotal</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.compare_at_price, "${{amount_no_decimals}}")}</p></>: */}
                    <p className="text-[1rem] font-medium">Subtotal: {currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    {/* } */}
                    
                  </div>
                  <div className="text-sm font-medium flex items-center">
                    <p className="mt-[0.5rem] mr-[0.25rem]">or pay in installements with</p>
                    <span className="sr-only">Affirm</span>
                    <svg width="41" height="16" viewBox="0 0 41 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.332 9.01542C2.23429 9.01542 0.961714 9.53279 0.272 10.0693L0.903429 11.3723C1.45714 10.8741 2.35086 10.4525 3.15714 10.4525C3.92457 10.4525 4.34229 10.7017 4.34229 11.2094C4.34229 11.5543 4.06057 11.7268 3.536 11.7939C1.55429 12.043 0 12.5795 0 14.0837C0 15.2717 0.864572 15.9999 2.20514 15.9999C3.16686 15.9999 4.02171 15.4729 4.42971 14.7831V15.8082H6.21714V11.5064C6.21714 9.73399 4.964 9.01542 3.332 9.01542ZM2.66171 14.6202C2.15657 14.6202 1.904 14.3807 1.904 13.9783C1.904 13.231 2.74914 12.9819 4.29371 12.819C4.30343 13.8154 3.61371 14.6202 2.66171 14.6202V14.6202ZM23.0714 10.3184V9.20704H21.284V15.8082H23.1977V12.6274C23.1977 11.1136 24.1206 10.6729 24.7714 10.6729C25.024 10.6729 25.364 10.7496 25.5874 10.9124L25.9371 9.16872C25.6457 9.04417 25.3349 9.01542 25.0823 9.01542C24.1011 9.01542 23.4794 9.44656 23.0714 10.3184V10.3184ZM34.816 9.01542C33.8057 9.01542 33.048 9.60944 32.6497 10.1747C32.2806 9.43698 31.5131 9.01542 30.5806 9.01542C29.5703 9.01542 28.8709 9.57111 28.5406 10.2034V9.20704H26.6949V15.8082H28.6086V12.407C28.6086 11.1903 29.2594 10.6058 29.8617 10.6058C30.4057 10.6058 30.9109 10.9508 30.9109 11.8514V15.8082H32.8343V12.407C32.8343 11.1711 33.4657 10.6058 34.0971 10.6058C34.6023 10.6058 35.1366 10.9699 35.1366 11.8418V15.8082H37.0503V11.2478C37.0503 9.76273 36.04 9.01542 34.816 9.01542V9.01542ZM12.9783 8.71842V9.20704H10.0737V8.53638C10.0737 7.66453 10.5789 7.41542 11.016 7.41542C11.2686 7.41542 11.5989 7.47291 11.8709 7.6262L12.4634 6.29447C12.1137 6.09327 11.5406 5.91123 10.7731 5.91123C9.54914 5.91123 8.16 6.59147 8.16 8.728V9.21662H7.05257V10.6729H8.16V15.8082H10.0737V10.6633H12.9783V15.8082H14.892V10.6633H16.6309V9.20704H14.892V8.53638C14.892 7.66453 15.3971 7.41542 15.8343 7.41542C16.32 7.41542 16.6891 7.6262 16.6891 7.6262L17.2817 6.29447C17.2817 6.29447 16.6794 5.91123 15.5914 5.91123C14.3771 5.90165 12.9783 6.58189 12.9783 8.71842V8.71842ZM17.7674 9.20704H19.6811V15.8082H17.7674V9.20704Z" fill="#060809"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.919 0C23.751 0 19.1464 3.53533 17.8447 8.08623H19.7196C20.8076 4.69461 24.5087 1.72455 28.919 1.72455C34.2813 1.72455 38.9053 5.7485 38.9053 12.0144C38.9053 13.4228 38.7207 14.6874 38.371 15.8084H40.1876L40.207 15.7509C40.5082 14.5916 40.6539 13.3365 40.6539 12.0144C40.6539 5.02994 35.4956 0 28.919 0Z" fill="#0FA0EA"/>
                    </svg>
                  </div>
                  {state.flow=="pmp"?<div className="mt-[3rem]">
                     <div className="w-72 mb-[1rem]">
                     <span className="new-h5 block mb-[1rem]">Please enter the order number of the wig?</span>
                      <div className="relative h-10 w-full min-w-[200px]">
                        <input
                        value={state.orderNo}
                        onChange={(e) => handleFieldChange("orderNo", e.target.value)}
                        className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-pink-500 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                        placeholder=" "
                        />
                        <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-pink-500 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-pink-500 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-pink-500 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                        Order Number
                        </label>
                      </div>
                    </div>
                    <label htmlFor="additional-requests">
                        <span className="new-h5 block">Additional styling request?</span>
                        <span className="block text-[1rem] mt-[0.5rem] mb-[1rem] leading-7">Feel free to share adjustments here and our team will reach out to you to confirm what’s possible. Don’t worry, we won’t get started on your unit until we’ve discussed your request.</span>
                      </label>
                    <textarea
                      id="additional-requests"
                      value={state.cartNote}
                      onChange={(e) => handleFieldChange("cartNote", e.target.value)}
                      className="w-full border-taupe-600 rounded-[0.5rem] p-[1rem] text-sm placeholder-[#535353]"
                      placeholder="Explain your request here, e.g. longer bangs"
                      rows={4}
                    ></textarea></div>:<div className="mt-[3rem]">
                    <label htmlFor="additional-requests">
                        <span className="new-h5 block">Additional styling request?</span>
                        <span className="block text-[1rem] mt-[0.5rem] mb-[1rem] leading-7">Feel free to share adjustments here and our team will reach out to you to confirm what’s possible. Don’t worry, we won’t get started on your unit until we’ve discussed your request.</span>
               
                      </label>
                    <textarea
                      id="additional-requests"
                      value={state.cartNote}
                      onChange={(e) => handleFieldChange("cartNote", e.target.value)}
                      className="w-full border-taupe-600 rounded-[0.5rem] p-[1rem] text-sm placeholder-[#535353]"
                      placeholder="Explain your request here, e.g. longer bangs"
                      rows={4}
                    ></textarea>
                  </div>
                   }
                  {state.flow=="pmp"?<></>: <div className="flex justify-center items-center mt-[2.5rem] lg:mt-[3rem]">
                    <svg aria-hidden="true" focusable="false" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#117456"/>
                    </svg>
                    <p className="font-medium text-xs text-mutedgreen ml-[1rem] leading-5">In Stock, ships within {shippingEstimate(state.variant)} business days | Free Shipping & Adjustments</p>
                   
                    </div>
                  }
               
                </>
              }
            </div>


          </div>
        )}
    </Transition>
  )
};